import { render, staticRenderFns } from "./policy-company-editor.vue?vue&type=template&id=0f29ce00&scoped=true&"
import script from "./policy-company-editor.vue?vue&type=script&lang=js&"
export * from "./policy-company-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29ce00",
  null
  
)

export default component.exports